import React, { useState } from "react"
import chunk from "lodash/chunk"
import styled from "styled-components"
import PostCard from "../Elements/PostCard"
import { categoryAccentClass } from "../../utils/category-classes"
const PostsRow = styled.div`
    @media (min-width: 450px) {
        display: flex;
        flex-wrap: wrap;
        & > div {
            margin-bottom: 48px;
        }
    }
    @media (min-width: 450px) and (max-width: 767px) {
        & > div {
            width: calc((100% - 24px) / 2);
            &:nth-child(odd) {
                margin-right: 24px;
            }
        }
    }
    @media screen and (min-width: 768px) and (max-width: 1023px) {
        & > div {
            width: calc((100% - 72px) / 4);
            &:not(:last-child) {
                margin-right: 24px;
            }
        }
    }
    @media screen and (min-width: 1024px) {
        & > div {
            width: calc((100% - 126px) / 4);
            margin-bottom: 72px;
            &:not(:last-child) {
                margin-right: 42px;
            }
        }
    }
    @supports (grid-gap: 0) {
        display: -ms-grid;
        display: grid;
        -ms-grid-columns: 1fr;
        grid-template-columns: repeat(1, 1fr);
        grid-gap: 0;
        margin-bottom: 48px;
        & > div {
            width: 100%;
            margin-right: 0;
        }
        @media screen and (min-width: 450px) {
            -ms-grid-columns: 1fr 24px 1fr;
            grid-template-columns: repeat(2, 1fr);
            grid-gap: 24px;
        }
        @media screen and (min-width: 768px) {
            -ms-grid-columns: 1fr 24px 1fr 24px 1fr 24px 1fr;
            grid-template-columns: repeat(4, 1fr);
            grid-gap: 24px;
        }
        @media screen and (min-width: 1024px) {
            margin-bottom: 70px;
            grid-gap: 42px;
        }
    }
`
const ArticlesCategory = styled.section`
    border-top: 1px solid #ddd;
    .category-list{
        // max-height: 400px;
        // overflow: hidden;
    }
    .post-row{
        margin-bottom: 1rem;
    }
`
export default ({ title, subTitle, posts, slug }) => {
    const [isShowMore, setIsShowMore] = useState();

    let showPosts = chunk(posts, 4);
    if (!isShowMore) {
        showPosts = showPosts.filter((chunkPosts, index) => index === 0)
    }
    const toggleShowMoreLess = () => {
        setIsShowMore(!isShowMore);
    }
    return (
    <ArticlesCategory className="bg-white">
        <span data-wa-depth="affordable-health-insurance-by-state:cost nationwide:depthTracking"></span>
        <div className="container">
            <div className="row justify-content-center text-center">
                <div className="col-md-9 col-lg-10 col-xl-9">
                    <h2 className="display-4">{title}</h2>
                    <div className={`${slug ? categoryAccentClass[slug] : 'null'} mx-auto title-gap`}></div>
                    <p className="lead font-weight-light mb-5">{subTitle}</p>
                </div>
            </div>
        </div>
        <div className="container container--grid">
            <div className="container__row category-list">
                {showPosts.map(
                    (chunkPosts, i) => (
                        <PostsRow key={`chunk-${i}`} className="post-row">
                            {chunkPosts.map(({ node: post }) => (
                                <PostCard
                                    className="post-card-wrap"
                                    key={post.wordpress_id}
                                    post={post}
                                    isPost
                                />
                            ))}
                        </PostsRow>
                    )
                )}
            </div>
            <div className="container__row text-center">
                <button className="button-tertiary" onClick={toggleShowMoreLess}>{isShowMore ? 'Show Less' : 'Load More'}</button>
            </div>
        </div>
    </ArticlesCategory>
)}
